export default __webpack_public_path__ + "static/DealerLocatorWidget-864a36c67818727e5becad5d113e2b52.jpg";